import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, IconButton, Paper, Typography } from "@mui/material";

import { ReactComponent as MicIcon } from "../assets/mic.svg";
import { ReactComponent as MicOnIcon } from "../assets/Group.svg";
import { ReactComponent as CloseIcon } from "../assets/close.svg";
import { ReactComponent as ChatVoice } from "../assets/chat_voice.svg";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import PatientListDialog from "../popup/PatientListDialog";
import Dashboard from "./Dashboard";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserLocalData } from "../lib/helper";
import GoogleTextToSpeech from "../common/GoogleTextToSpeech";
import { useLanguage } from "../context/LanguageContext";

const VoiceSearch = () => {
  const navigate = useNavigate();
  const { token, patient_id, session_id } = getUserLocalData();
  const { language, languageName } = useLanguage();
  const { transcript, finalTranscript, listening, resetTranscript } =
    useSpeechRecognition({});
  const location = useLocation();
  const validPatientId =
    patient_id && patient_id !== "undefined" ? patient_id : null;
  const validSessionId =
    session_id && session_id !== "undefined" ? session_id : null;
  const [patientList, setPatientList] = useState([]);
  const [isLoadingScreen, setIsLoadingScreen] = useState(true);

  const [open, setOpen] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [messageHistory, setSaveMessageHistory] = useState([]);
  const [activeState, setActiveState] = useState("");

  useEffect(() => {
    setActiveState(location?.state);
  }, [location?.state]);
  useEffect(() => {
    if (!listening && transcript.trim()) {
      sendMessage(new Event("submit"));
    }
  }, [listening]);

  useEffect(() => {
    setIsLoadingScreen(false);
    return () => {
      SpeechRecognition.abortListening();
      SpeechRecognition.stopListening();
      resetTranscript();
    };
  }, []);

  const sendMessage = async (e) => {
    if (!transcript.trim()) return; // Prevent empty submissions

    const userInput = transcript.trim();
    resetTranscript(); // Reset voice input

    try {
      if (!validPatientId) {
        // This is for patient list purposes
        const response = await axios.post(
          `${process.env.REACT_APP_QUERY_URL}?query=${userInput}&access_token=${token}&language=${languageName}`
        );

        if (response?.data) {
          // setPatientList(response?.data?.patients);
          setPatientList(response?.data?.patient);
          setOpen(true);
          setResponseMessage(response?.data?.response);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const onChatClick = () => {
    navigate("/chat", {
      state: { messageHistory, conversationId: validSessionId },
    });
  };

  const onCancelClick = () => {
    if (validPatientId) {
      // navigate(-1);
    } else {
      onChatClick();
    }
  };

  const saveConversation = (messages) => {
    setSaveMessageHistory([...messageHistory, ...messages]);
  };

  return (
    <>
      {open && (
        <PatientListDialog
          open={open}
          setOpen={setOpen}
          data={patientList}
          message={responseMessage}
        />
      )}
      <Dashboard active={activeState ? activeState : "voice"}>
        <Box className="main-content" elevation={3}>
          {!listening && (
            <>
              <Box component={"div"} className="text-container">
                <Typography
                  variant="mSize"
                  className="speak-to-mary font-w-500 white-color"
                >
                  Speaking to MARY
                </Typography>

                <Typography
                  variant="lSize"
                  className="go-ahead font-w-400 black-color-3"
                  my={2}
                >
                  Go ahead, I'm Listening
                </Typography>
                {!validPatientId ? (
                  <Typography
                    variant="fs12"
                    className="font-w-400 black-color-3"
                    my={1}
                  >
                    Search patient by firstname, lastname and date of birth
                  </Typography>
                ) : null}
              </Box>
            </>
          )}
          {/* {validPatientId ? (
            <>
              <Typography
                variant="fs12"
                className="font-w-400 black-color-3"
                my={1}
              >
                {`Patient Name: ${patient_name}`}
              </Typography>
            </>
          ) : null} */}
          <Box className="wave" component={"div"}></Box>
          <Box>
            {!isLoadingScreen ? (
              <GoogleTextToSpeech
                transcript={transcript}
                listening={listening}
                saveConversation={saveConversation}
                resetTranscript={resetTranscript}
                isPopUpOpen={open}
              />
            ) : null}
            <Box component={"div"} className="mic-container">
              <Box
                component="div"
                elevation={0}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row",
                  px: 2,
                  flex: 1,
                }}
                className="message-box"
                onSubmit={(e) => {
                  e.preventDefault(); // ✅ Prevents default form submission
                  sendMessage();
                }}
              >
                {/* Input Field */}
                <IconButton sx={{ margin: "auto" }} onClick={onChatClick}>
                  <ChatVoice />
                </IconButton>
                <IconButton
                  sx={{ flex: 1, margin: "auto" }}
                  onClick={() =>
                    SpeechRecognition.startListening({
                      continuous: false,
                      language: language
                    })
                  }
                >
                  {!listening && (
                    <Box className="mic-icon">
                      <MicIcon width={100} height={100} />
                    </Box>
                  )}
                  {listening && (
                    <Box className="mic-icon">
                      <MicOnIcon width={100} height={100} />
                    </Box>
                  )}
                </IconButton>
                <IconButton sx={{ margin: "auto" }} onClick={onCancelClick}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
          </Box>
        </Box>
      </Dashboard>
    </>
  );
};

export default VoiceSearch;
